export default "__VITE_ASSET__DcPz73fR__"